import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab, Grid, Paper, TextField, Typography } from '@material-ui/core';
import ExitIcon from '@material-ui/icons/Clear';
import LaunchIcon from '@material-ui/icons/Launch';
import { useState } from 'react';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import ImposteContributi from './ImposteContributi';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function ContoEconomicoProfessionista(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeContoEconomicoProfessionista";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();
    const [ImposteContributiDialogOpen, SetImposteContributiDialogOpen] = useState(false);

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    const handleClose = (e: any) => {
        SetImposteContributiDialogOpen(false);
        API_elaboraSchedaBudget(props, global);
    }

    const apriModal = (e: number) => {
        SetImposteContributiDialogOpen(true);
    }

    const handleChangeChild = (act: string, name: string, value: any) => {
        props.handleChange(act, name, value);
    }

    return (
        <Paper className={gClasses.mainPaper}>
            <Dialog
                open={ImposteContributiDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Imposte e contributi</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <ImposteContributi handleChange={handleChangeChild} state={state} />
                </DialogContent>
                <DialogActions>
                    <Fab onClick={handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            <Typography variant="h6">Professionista</Typography>
            <TextField
                name="nomeDitta"
                label="Professionista"
                value={state.informazioniCostiDiAvvio.nomeDitta}
                className={gClasses.longTextFieldReadOnly}
                InputLabelProps={{
                    shrink: true,
                    disabled: true
                }}
                inputProps={{tabIndex: -1}}
                margin="normal"
            />

            <Typography variant="body1">
                Al fine di conferire maggiore efficacia alla simulazione, si ipotizzi una situazione
                a regime, per la quale si determina un risultato "di competenza", attraverso la deduzione
                dei contributi previdenziali direttamente dal reddito sul quale sono dovuti.
            </Typography>

            <NumberField
                name="J70_Compensi"
                label="Compensi"
                value={state.contoEconomicoProfessionista.J70_Compensi}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />

            <SectionTitle text="Costi e spese"></SectionTitle>

            <NumberField
                name="J73_Dipendenti"
                label="Dipendenti: stipendi, contr., ecc."
                value={state.contoEconomicoProfessionista.J73_Dipendenti}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="J74_Compensi_Terzi"
                label="Compensi corrisposti a terzi per prestazioni"
                value={state.contoEconomicoProfessionista.J74_Compensi_Terzi}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />

            {/* <SectionTitle text="Altre spese ed oneri:"></SectionTitle> */}

            <NumberField
                name="G76_Energia"
                label="Energia"
                value={state.contoEconomicoProfessionista.G76_Energia}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G77_Riparazioni"
                label="Manut. e riparazioni"
                value={state.contoEconomicoProfessionista.G77_Riparazioni}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="K25_totale"
                label="Ammortamenti"
                value={state.informazioniCostiDiAvvio.K25_totale}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="G79_Servizi_Contabili"
                label="Servizi contabili"
                value={state.contoEconomicoProfessionista.G79_Servizi_Contabili}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G80_Spese_Telefoniche"
                label="Spese telefoniche"
                value={state.contoEconomicoProfessionista.G80_Spese_Telefoniche}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G81_Affitto_Locali"
                label="Affitto locali"
                value={state.contoEconomicoProfessionista.G81_Affitto_Locali}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G82_Assicurazioni"
                label="Assicurazioni"
                value={state.contoEconomicoProfessionista.G82_Assicurazioni}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G83_Agg_Profess"
                label="Aggiornam. profess."
                value={state.contoEconomicoProfessionista.G83_Agg_Profess}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G84_Carburanti"
                label="Carburanti e lubrif."
                value={state.contoEconomicoProfessionista.G84_Carburanti}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="G85_Interessi_Passivi"
                label="Interessi passivi"
                value={state.contoEconomicoProfessionista.G85_Interessi_Passivi}
                className={gClasses.textField}
                onBlur={handleBlur}
                onChange={handleChange}
            />
            <NumberField
                name="J88_Totale_Costi"
                label="Totale costi e spese"
                value={state.contoEconomicoProfessionista.J88_Totale_Costi}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="J90_Risultato_Netto"
                label="Risultato netto"
                value={state.contoEconomicoProfessionista.J90_Risultato_Netto}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <Divider></Divider>
            <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                <Button onClick={() => apriModal(2)} style={{ cursor: "pointer", marginTop: "10px" }}>
                    <React.Fragment>
                        <Typography variant="h6" style={{ textTransform: "none" }}>Imposte e contributi</Typography>
                        <LaunchIcon style={{ marginLeft: "5px", marginBottom: "5px", height: "17px" }} color="secondary"></LaunchIcon>
                    </React.Fragment>
                </Button>
                <Grid container direction="row">
                    <NumberField
                        name="G93_irap"
                        label="IRAP"
                        value={state.contoEconomicoProfessionista.G93_irap}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G94_irpef_addizionali"
                        label="IRPEF + addizionali"
                        value={state.contoEconomicoProfessionista.G94_irpef_addizionali}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="J94_totale"
                    label="Totale"
                    value={state.contoEconomicoProfessionista.J94_totale}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="J97_contributi_previdenziali"
                    label="Contributi Previdenziali"
                    value={state.contoEconomicoProfessionista.J97_contributi_previdenziali}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="J99_Reddito_Disponibile"
                    label="Reddito disponibile"
                    value={state.contoEconomicoProfessionista.J99_Reddito_Disponibile}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </Grid>
        </Paper>
    )
}